import { useState } from "react"

import { useNavigate, useParams } from "react-router-dom"

import { AppSidebar } from "@/components/layouts/app-layout/app-sidebar"
import { SidebarSearchButton } from "@/components/sidebar/sidebar-search-button"
import { SidebarGroup, SidebarMenu, SidebarMenuItem } from "@/components/ui/sidebar"
import { useSidebar } from "@/components/ui/use-sidebar"
import { cn } from "@/lib/utils"

import { StartNewFlowButton } from "./start-new-flow-button"
import { WorkflowsFolder } from "./workflows-folder"

export function WorkflowEditorSidebar() {
  const { state, isMobile } = useSidebar()
  const navigate = useNavigate()
  const { id: currentWorkflowId } = useParams<{ id: string }>()

  const [globalSearch, setGlobalSearch] = useState("")

  const isCollapsed = state === "collapsed" && !isMobile

  const handleLogoClick = () => {
    void navigate("/flows")
  }

  return (
    <AppSidebar onLogoClick={handleLogoClick}>
      <SidebarGroup className="bg-sidebar sticky top-0 z-40 gap-2 p-2 pb-0">
        <SidebarMenu>
          <SidebarMenuItem className={cn("flex", isCollapsed ? "justify-center" : "")}>
            <StartNewFlowButton iconOnly={isCollapsed} />
          </SidebarMenuItem>
        </SidebarMenu>
        {!isCollapsed && (
          <SidebarSearchButton searchValue={globalSearch} onSearchChange={setGlobalSearch} />
        )}
      </SidebarGroup>

      <SidebarGroup
        className={cn("flex flex-col gap-2 p-2", isCollapsed ? "items-center pt-1" : "")}
      >
        <WorkflowsFolder
          showDeleteAction
          stickyShowLess
          currentWorkflowId={currentWorkflowId}
          globalSearchTerm={globalSearch}
          visibleCount={15}
        />
      </SidebarGroup>
    </AppSidebar>
  )
}
